import { Box, Stack, Typography } from "@mui/material";

const ParticipationBreakdown = ({
  isOverall = false,
  lowParticipationPercent,
}: {
  isOverall?: boolean;
  lowParticipationPercent: number;
}) => (
  <Stack direction="row" sx={{ ml: 3 }}>
    <Typography
      variant="bodySecondaryReg"
      sx={{
        color: isOverall ? "shades.primary.500" : "shades.neutral.500",
        fontWeight: isOverall ? 500 : 400,
      }}
    >
      {lowParticipationPercent}%
    </Typography>
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.125}
      sx={{ width: "100%", maxWidth: "100px", ml: 2 }}
    >
      <Box
        sx={{
          bgcolor: "shades.meadow.500",
          height: "12px",
          borderRadius: "5px",
          width: `${100 - lowParticipationPercent}%`,
        }}
      />
      <Box
        sx={{
          bgcolor: "shades.negative.500",
          height: "12px",
          borderRadius: "5px",
          width: `${lowParticipationPercent}%`,
        }}
      />
    </Stack>
  </Stack>
);

export default ParticipationBreakdown;
